'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = require('immutable');

var _asyncStatuses = require('./constants/asyncStatuses');

/**
 * AsyncData is a record that stores a status along side state for asynchronous data (eg: network requests, pub sub)
 *
 * Use Cases:
 * - Single data object (eg: portal settings, user settings)
 * - Collection of data that is returned in a single request that may or may not be paginated (eg: inbox views, threads)
 * - Indexed Collection that is fetched individually (eg: thread histories, contacts, responders)
 * - Indexed Collection that is fetched in bulk (eg: tickets, deals)
 *
 * @param {Object|Map} props
 * @param {Any} [props.data=null] data that is asynchronous
 * @param {Map} [status=UNINITIALIZED] the current state of the asynchronous operation
 *
 * @example <caption>Single data object or a collection of data that is returned in a single request</caption>
 * const initialState = AsyncData();
 *
 * handleActions(
 *   {
 *     [GET_THING_STARTED](state) {
 *         return requestStarted(state);
 *     },
 *     [GET_THING_SUCCEEDED](state, action) {
 *         return requestSucceededWithOperator(() => action.payload.data, state);
 *     },
 *     [GET_THING_FAILED](state) {
 *         return requestFailed(state);
 *     },
 *  },
 *  initialState
 *  );
 *
 * @example <caption>Collection of paginated data</caption>
 * const initialState = AsyncData({
 *   data: Map({
 *      items: Map(),
 *      offset: 0,
 *   })
 * });
 *
 * handleActions(
 *   {
 *     [GET_PAGINATED_THING_STARTED](state) {
 *         return requestStarted(state);
 *     },
 *     [GET_PAGINATED_THING_SUCCEEDED](state, action) {
 *         return requestSucceededWithOperator(existing => (
 *           existing
 *             .update('items', items => items.merge(action.payload.data))
 *             .set('offset', action.payload.offset)
 *         ), state);
 *     },
 *     [GET_PAGINATED_THING_FAILED](state) {
 *        return requestFailed(state);
 *     },
 *  },
 *  initialState
 *  );
 *
 * @example <caption>AsyncData State</caption>
 * AsyncData {
 *    data: InboxViews,
 *    status: 'SUCCEEDED'
 * }
 */
exports.default = (0, _immutable.Record)({
  data: null,
  status: _asyncStatuses.UNINITIALIZED
}, 'AsyncData');
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-internal-schema/static-1.4266/js/async-data/AsyncData.js
// module id = 103
// module chunks = 2 3